export default {
  'empty.svg': 'empty.svg',
  'failed.svg': 'failed.svg',
  'search.svg': 'search.svg',
  'success.svg': 'success.svg',
  'warning.png': 'warning.png',
}
